// extracted by mini-css-extract-plugin
export default {"container":"D0-z","heading":"E0-z","links":"F0-z","copy":"G0-z","subCopy":"H0-z","linksLeft":"I0-z","linksCenter":"J0-z","linksRight":"K0-z","link":"L0-z","onlyLink":"M0-z"};